(function () {
    'use strict';

    angular
        .module('bizmetryApp')
        .controller('TemplateDiffDialogController', TemplateDiffDialogController);

    TemplateDiffDialogController.$inject = [
        '$scope', '$mdDialog', '$mdToast', '$timeout',
        'TemplateInstanceService',
        'childTemplateRef', 'parentTemplateRef'
    ];

    function TemplateDiffDialogController(
        $scope, $mdDialog, $mdToast, $timeout,
        TemplateInstanceService,
        childTemplateRef, parentTemplateRef
    ) {
        $scope.loading        = true;
        $scope.childTemplate  = childTemplateRef;
        $scope.parentTemplate = parentTemplateRef || { templateVersion: 'unknown' };

        $scope.diffResult = {
            asbos:       [],
            clientTypes: [],
            domains:     [],
            frameTypes:  [],
            apiCollections: [],
            summary:     { totalAdded: 0, totalRemoved: 0, totalChanged: 0 },
            isEmpty:     true
        };

        // ── Close ───────────────────────────────────────────────────────
        $scope.close = function () { $mdDialog.hide(); };

        // ── Frame Component helpers ─────────────────────────────────────

        $scope.hasNestedCols = function (comp) {
            return comp.componentType === 'NESTED_TABLE'
                && comp.nestedColumnDiffs
                && comp.nestedColumnDiffs.length > 0;
        };

        $scope.toggleCompCols = function (comp) {
            if ($scope.hasNestedCols(comp)) {
                comp._open = !comp._open;
            }
        };

        $scope.hasVisibleFieldChanges = function (comp) {
            if (!comp.fieldChanges || comp.fieldChanges.length === 0) return false;
            return comp.fieldChanges.some(function (fc) {
                if (fc.changeHint === 'COLUMNS_CHANGED') return false;
                if (fc.changeHint === 'TYPE_CHANGED' && comp.previousComponentType) return false;
                return true;
            });
        };

        // ── Env Mapping diff helpers ────────────────────────────────────

        /**
         * Detecta si un fieldChange corresponde a env mappings.
         * Cachea el resultado en fc._isEnvMapping para no recalcular en cada digest.
         */
        $scope.isEnvMappingChange = function (fc) {
            if (!fc) return false;
            if (fc._isEnvMapping === undefined) {
                fc._isEnvMapping = !!(fc.label && fc.label.toUpperCase().indexOf('ENVIRONMENT') !== -1);
            }
            return fc._isEnvMapping;
        };

        /**
         * Parsea el string de env mappings separado por pipes.
         * Ej: "Development → MARIVA-DESA-001.schema.TABLE [master] | QA → MARIVA-QA-001.schema.TABLE"
         */
        function parseEnvMappings(str) {
            if (!str) return [];
            return str.split(' | ').map(function (part) {
                var arrowIdx = part.indexOf(' \u2192 ');   // →
                if (arrowIdx === -1) return { env: part.trim(), target: '' };
                return {
                    env:    part.substring(0, arrowIdx).trim(),
                    target: part.substring(arrowIdx + 3).trim()
                };
            }).filter(function (m) { return m.env; });
        }

        /**
         * Compara los env mappings de from vs to y devuelve un array con estado por mapping.
         * CRÍTICO: cachea el resultado en fc._envMappingDiff para evitar infinite digest —
         * AngularJS re-evalúa expresiones del template en cada digest cycle; si la función
         * retorna un nuevo array cada vez, el watcher nunca detecta estabilidad.
         */
        $scope.diffEnvMappings = function (fc) {
            if (fc._envMappingDiff) return fc._envMappingDiff;

            var fromList = parseEnvMappings(fc.from);
            var toList   = parseEnvMappings(fc.to);

            var fromMap = {}, toMap = {};
            fromList.forEach(function (m) { fromMap[m.env] = m.target; });
            toList.forEach(function (m)   { toMap[m.env]   = m.target; });

            var result = [];

            // unchanged / changed / removed
            fromList.forEach(function (m) {
                if (!toMap.hasOwnProperty(m.env)) {
                    result.push({ env: m.env, target: m.target, state: 'removed' });
                } else if (toMap[m.env] !== m.target) {
                    result.push({ env: m.env, fromTarget: m.target, toTarget: toMap[m.env], state: 'changed' });
                } else {
                    result.push({ env: m.env, target: m.target, state: 'unchanged' });
                }
            });

            // added
            toList.forEach(function (m) {
                if (!fromMap.hasOwnProperty(m.env)) {
                    result.push({ env: m.env, target: m.target, state: 'added' });
                }
            });

            fc._envMappingDiff = result;
            return fc._envMappingDiff;
        };

        // ── Fix Material flex-center en md-dialog-content ──────────────
        function fixDialogAlignment() {
            var dialog = document.querySelector('.template-diff-dialog');
            if (!dialog) return;

            var contents = dialog.querySelectorAll('md-dialog-content');
            contents.forEach(function (el) {
                el.style.setProperty('display', 'block', 'important');
                el.style.setProperty('align-items', 'flex-start', 'important');
            });

            var inners = dialog.querySelectorAll('.md-dialog-content');
            inners.forEach(function (el) {
                el.style.setProperty('display', 'block', 'important');
                el.style.setProperty('width', '100%', 'important');
                el.style.setProperty('max-width', 'none', 'important');
                el.style.setProperty('margin', '0', 'important');
                el.style.setProperty('padding', '0', 'important');
            });

            var bodies = dialog.querySelectorAll('.md-dialog-content-body');
            bodies.forEach(function (el) {
                el.style.setProperty('display', 'block', 'important');
                el.style.setProperty('width', '100%', 'important');
                el.style.setProperty('max-width', 'none', 'important');
                el.style.setProperty('margin', '0', 'important');
                el.style.setProperty('padding', '0', 'important');
            });

            var diffBodies = dialog.querySelectorAll('.diff-body');
            diffBodies.forEach(function (el) {
                el.style.setProperty('display', 'block', 'important');
                el.style.setProperty('width', '100%', 'important');
                el.style.setProperty('align-self', 'stretch', 'important');
            });
        }

        $timeout(fixDialogAlignment, 0);
        $timeout(fixDialogAlignment, 300);

        // ── Load & diff via backend API ─────────────────────────────────
        function loadAndDiff() {
            if (!parentTemplateRef || !parentTemplateRef.id) {
                $scope.loading = false;
                $mdToast.show($mdToast.simple()
                    .textContent('Parent template not found in loaded versions')
                    .position('top right')
                    .hideDelay(3000));
                return;
            }

            TemplateInstanceService.diffTemplateInstances(
                childTemplateRef.id,
                parentTemplateRef.id
            )
            .then(function (response) {
                var data = response.data || {};

                $scope.diffResult = {
                    asbos:       data.asbos       || [],
                    clientTypes: data.clientTypes  || [],
                    domains:     data.domains      || [],
                    frameTypes:  data.frameTypes   || [],
                    apiCollections: data.apiCollections || [],
                    summary:     data.summary      || { totalAdded: 0, totalRemoved: 0, totalChanged: 0 },
                    isEmpty:     data.summary      ? data.summary.empty : true
                };

                $scope.loading = false;

                $timeout(fixDialogAlignment, 300);
            })
            .catch(function (err) {
                console.error('Diff API error:', err);
                $scope.loading = false;
                $mdToast.show($mdToast.simple()
                    .textContent('Error computing template diff')
                    .position('top right')
                    .hideDelay(3000));
            });
        }

        loadAndDiff();
    }

})();